(() => {
  const root = document.getElementById('MainContent');
  const config = document.getElementById('mv-landing-motion-labels');
  if (!root || !config || root.dataset.mvlReady) return;
  root.dataset.mvlReady = 'true';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const galleries = new Map();
  const panels = new Map();
  const seen = new WeakSet();
  const animations = new Set();
  const interactive = 'details,form,product-form,media-gallery,.sticky-atc,.mvb,product-modal,.quick-add-modal,.shopify-app-block';
  const animated = '.animate-item,[data-mv-reveal],.mv-split,.mv-unveil,[data-mv-skip],.mv-hh-section,.mv-ht-section,.mv-cf-section,.mv-bt-section,.mv-rt-section';
  const animate = (element, frames, options) => {
    if (reduce.matches || !element.animate) return null;
    const animation = element.animate(frames, options);
    animations.add(animation);
    animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
    return animation;
  };
  const update = () => {
    galleries.forEach(state => {
      const rect = state.image.getBoundingClientRect();
      const visible = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
      state.image.classList.toggle('mvl-playing', visible && state.visible && !reduce.matches && !document.hidden && !state.gallery.matches(':focus-within'));
    });
  };
  const galleryObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = galleries.get(entry.target);
      if (state) state.visible = entry.isIntersecting;
    });
    update();
  }, {threshold: 0.1}) : null;
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    let index = 0;
    entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top).forEach(entry => {
      revealObserver.unobserve(entry.target);
      animate(entry.target, [{opacity: .35, translate:'0 16px'}, {opacity:1, translate:'0 0'}], {duration:620, delay:Math.min(index++,4)*65, easing:'cubic-bezier(.22,.8,.25,1)'});
      entry.target.dataset.mvlRevealed = 'true';
    });
  }, {threshold:0, rootMargin:'0px 0px -24px 0px'}) : null;
  const scan = scope => {
    scope.querySelectorAll('media-gallery').forEach(gallery => {
      if (galleries.has(gallery) || gallery.closest('.quick-add-modal,product-modal')) return;
      const image = gallery.querySelector('.product__media-item:first-child .product__media img');
      if (!image) return;
      image.classList.add('mvl-float');
      const state = {gallery,image,visible:false};
      galleries.set(gallery,state);
      gallery.addEventListener('focusin',update);
      gallery.addEventListener('focusout',() => requestAnimationFrame(update));
      gallery.querySelector('.product__media-list')?.addEventListener('scroll',update,{passive:true});
      if (galleryObserver) galleryObserver.observe(gallery);
    });
    scope.querySelectorAll('h2,.rte > p,table tbody tr,.multicolumn-card__info,.image-with-text__text').forEach(element => {
      if (seen.has(element) || element.closest(interactive) || element.closest(animated) || element.querySelector(animated)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top < innerHeight || reduce.matches || !revealObserver) return;
      revealObserver.observe(element);
    });
    scope.querySelectorAll('details').forEach(details => {
      if (panels.has(details) || details.matches('.accordion__details') || details.closest('media-gallery,product-form,form,.quick-add-modal')) return;
      const summary = details.querySelector(':scope > summary');
      const content = [...details.children].filter(el => el !== summary);
      if (!summary || !content.length) return;
      const state = {details,summary,content,closing:false,current:[]};
      panels.set(details,state);
      details.addEventListener('toggle',() => summary.setAttribute('aria-expanded',String(details.open)));
      summary.addEventListener('click',event => {
        if (reduce.matches || !details.animate) return;
        event.preventDefault();
        state.current.forEach(animation => animation?.cancel());
        if (!details.open || state.closing) {
          state.closing = false;
          details.open = true;
          summary.setAttribute('aria-expanded','true');
          state.current = content.map(el => animate(el,[{opacity:0,translate:'0 -6px'},{opacity:1,translate:'0 0'}],{duration:300,easing:'ease-out'}));
        } else {
          state.closing = true;
          state.current = content.map(el => animate(el,[{opacity:1,translate:'0 0'},{opacity:0,translate:'0 -4px'}],{duration:180,easing:'ease-in',fill:'forwards'}));
          Promise.all(state.current.map(animation => animation?.finished)).then(() => {
            if (!state.closing) return;
            details.open = false;
            summary.setAttribute('aria-expanded','false');
            state.closing = false;
            state.current.forEach(animation => animation?.cancel());
          }).catch(() => {});
        }
      });
    });
    update();
  };
  scan(root);
  document.addEventListener('visibilitychange',update);
  reduce.addEventListener('change',() => {
    if (reduce.matches) {
      animations.forEach(animation => animation.cancel());
      panels.forEach(state => {
        if (state.closing) { state.details.open = false; state.summary.setAttribute('aria-expanded','false'); state.closing = false; }
      });
    }
    update();
  });
  document.addEventListener('shopify:section:load',event => scan(event.target));
  document.addEventListener('shopify:section:unload',() => {
    galleries.forEach((state,element) => {
      if (element.isConnected) return;
      galleryObserver?.unobserve(element);
      galleries.delete(element);
    });
    panels.forEach((state,element) => { if (!element.isConnected) panels.delete(element); });
  });
})();
(() => {
  const root = document.getElementById('MainContent');
  if (!root || root.dataset.mvxReady) return;
  root.dataset.mvxReady = 'true';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover:hover) and (pointer:fine)');
  const seen = new WeakSet();
  const running = new Set();
  const mediaSelector = '.mv-pl__media,.image-with-text__media';
  const tileSelector = '.card-wrapper,.multicolumn-card,.mv-pl-ship__card,.mv-pl-card';
  const featureSelector = '.mv-pl-fact,.mv-pl-table__row,.mv-pl-card,table tbody tr';
  const buttonSelector = '.button:not([disabled]):not(.quantity__button):not(.sticky-atc__button)';
  const excluded = 'product-modal,.quick-add-modal,cart-drawer,.sticky-atc,.mvb,.shopify-app-block,[data-mv-skip]';
  const play = (element,frames,options) => {
    if (reduce.matches || !element.animate || document.hidden) return;
    const motion = element.animate(frames,options);
    running.add(motion);
    motion.finished.then(()=>running.delete(motion),()=>running.delete(motion));
  };
  const sweep = element => {
    if (reduce.matches || document.hidden || element.classList.contains('mvx-sweep')) return;
    element.classList.add('mvx-sweep');
    element.querySelector(':scope > .mvx-sheen')?.addEventListener('animationend',()=>element.classList.remove('mvx-sweep'),{once:true});
  };
  const addSheen = element => {
    const span = document.createElement('span');
    span.className = 'mvx-sheen';
    span.setAttribute('aria-hidden','true');
    element.append(span);
    element.addEventListener('pointerenter',()=>{if(pointer.matches)sweep(element);});
    element.addEventListener('focusin',()=>sweep(element));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    let index=0;
    entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top).forEach(entry=>{
      observer.unobserve(entry.target);
      const element=entry.target;
      element.dataset.mvxSeen='true';
      if (element.classList.contains('mvx-media') || element.classList.contains('mvx-button')) sweep(element);
      if (element.matches(mediaSelector)) {
        const image=element.querySelector('img');
        if(image && element.dataset.mvxBelow==='true') {
          const baseScale = parseFloat(getComputedStyle(image).scale) || 1;
          play(image,[{scale:String(baseScale*1.07)},{scale:String(baseScale)}],{duration:3800,easing:'cubic-bezier(.16,.84,.3,1)'});
        }
      }
      if (element.classList.contains('mvx-feature')) play(element,[{translate:'-15px 0'},{translate:'0 0'}],{duration:650,delay:Math.min(index++,5)*80,easing:'cubic-bezier(.16,.84,.3,1)'});
    });
  },{threshold:.15}) : null;
  const scan = scope => {
    scope.querySelectorAll([mediaSelector,tileSelector,featureSelector,buttonSelector,'.product__media-item:first-child .product__media'].join(',')).forEach(element=>{
      if(seen.has(element)||element.closest(excluded))return;
      seen.add(element);
      element.dataset.mvxBelow=String(element.getBoundingClientRect().top>=innerHeight);
      if(element.matches(mediaSelector+',.product__media')) {
        element.classList.add('mvx-media');
        addSheen(element);
      }
      if(element.matches(buttonSelector)) {
        element.classList.add('mvx-button');
        addSheen(element);
      }
      if(element.matches(featureSelector))element.classList.add('mvx-feature');
      if(element.matches(tileSelector)) {
        element.classList.add('mvx-tilt');
        let frame=0;
        element.addEventListener('pointermove',event=>{
          if(!pointer.matches||reduce.matches||event.pointerType!=='mouse')return;
          cancelAnimationFrame(frame);
          frame=requestAnimationFrame(()=>{
            const r=element.getBoundingClientRect();
            element.style.setProperty('--mvx-rx',((.5-(event.clientY-r.top)/r.height)*5).toFixed(2)+'deg');
            element.style.setProperty('--mvx-ry',(((event.clientX-r.left)/r.width-.5)*5).toFixed(2)+'deg');
            element.classList.add('mvx-tracking');
          });
        });
        element.addEventListener('pointerleave',()=>{cancelAnimationFrame(frame);element.classList.remove('mvx-tracking');});
      }
      if(observer)observer.observe(element);
    });
  };
  scan(root);
  reduce.addEventListener('change',()=>{
    if(!reduce.matches)return;
    running.forEach(animation=>animation.cancel());
    root.querySelectorAll('.mvx-tracking,.mvx-sweep').forEach(element=>element.classList.remove('mvx-tracking','mvx-sweep'));
  });
  document.addEventListener('visibilitychange',()=>{
    running.forEach(animation=>document.hidden?animation.pause():animation.play());
  });
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('[data-mvx-below]').forEach(element=>observer?.unobserve(element));
  });
  let pending=false;
  const added = new Set();
  new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(node=>{
      if(node.nodeType===1 && !node.matches('.mvx-sheen'))added.add(node.parentElement||node);
    }));
    if(pending||!added.size)return;
    pending=true;
    requestAnimationFrame(()=>{pending=false;added.forEach(node=>{if(node.isConnected)scan(node);});added.clear();});
  }).observe(root,{childList:true,subtree:true});
})();
